<template>
  <div class="navbar-button" v-if="!signedIn">
    <div class="navbar-action">
      <a href='#' @click="loginClicked" class="navbar-action">Login</a>
    </div>
  </div>

  <div class="navbar-line1" v-if="signedIn">
    <div class="welcome-msg">Welcome {{userName}}!</div>
  </div>
  <div class="navbar-button" v-if="signedIn">
    <a href='#' @click="logoutClicked" class="navbar-action">Logout</a>
  </div>

  <div :class="{'is-active': showLogin}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-signIn">
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div class="level">
            <div class="level-item">
              <img class="login-header-logo" src="\2290taxlogo.png">
            </div>
          </div>
          <div v-if="errorMessage && errorMessage.length > 0" class="validation-errors">
            <p class="error-msg">{{errorMessage}}</p>
          </div>

          <div class="field">
            <label class="sec-label">Email Address<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="text" v-model="username">
            </div>
          </div>
          <div class="field">
            <label class="sec-label">Password<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="password" v-model="password">
            </div>
          </div>
          <div class="level xxsecurity-content-link">
            <div class="level-item xxhas-text-centered">
              <a @click="forgotPasswordClicked" href='#'>Forgot Password</a>
            </div>
            <div class="level-item xxhas-text-centered">
              <a @click="registerClicked" href='#'>Sign Up</a>
            </div>
          </div>
          <div class="level">
            <div class="level-item has-text-centered">
              <button :disabled="!isRequiredLoginDataProvided" @click="login"
                class="button is-primary is-rounded button-padded">
                Sign In
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div :class="{'is-active': showForgotPassword}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-register">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="security-header-label">Forgot Your Password?</div>
          </div>
        </div>
        <div class="level-right">
          <div class="level item">
            <img class="security-header-logo" src="\2290taxlogo.png">
          </div>
        </div>
      </div>
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div class="field">
            <p class="label">Enter your email address and we will send you
              a verification code to reset your password.
            </p>
          </div>

          <div class="field">
            <label class="label">Email<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter Email Address" v-model="email">
            </div>
          </div>

          <div class="level">
            <div class="level-item">
              <button @click="sendForgotPasswordEmailClicked"
                  class="send-verify-button button is-primary">
                Send Verification Code
              </button>
            </div>
          </div>
          <p class="bail-out-message has-text-centered">
            <a href='#' @click="cancelForgotPasswordClicked">Cancel</a>
          </p>

        </div>
      </div>
    </div>
  </div>

  <div :class="{'is-active': showForgotPasswordConfirmation}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-register">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="security-header-label">Reset Your Password</div>
          </div>
        </div>
        <div class="level-right">
          <div class="level item">
            <img class="security-header-logo" src="\2290taxlogo.png">
          </div>
        </div>
      </div>
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div v-if="errorMessage && errorMessage.length > 0" class="validation-errors">
            <p class="error-msg">{{errorMessage}}</p>
          </div>

          <div class="field">
            <p class="label">Please enter the verification code we sent to you via email along
              with your new password.
            </p>
          </div>

          <div class="field">
            <label class="sec-label">Confirmation Code<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="text" placeholder="Confirmation Code"
               v-model="emailConfirmationCode">
            </div>
          </div>

          <div class="field">
            <p>Passwords must contain at least 8 characters with at least 1: number,
              symbol, uppercase, lowercase.</p>
          </div>

          <div class="field">
            <label class="sec-label">New Password<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="password" v-model="password">
            </div>
          </div>

          <div class="level">
            <div class="level-item">
              <button @click="updateForgottenPasswordClicked"
                  class="send-verify-button button is-primary">
                Update Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div :class="{'is-active': showRegister}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-register">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="security-header-label">Sign Up</div>
          </div>
        </div>
        <div class="level-right">
          <div class="level item">
            <img class="security-header-logo" src="\2290taxlogo.png">
          </div>
        </div>
      </div>
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div v-if="errorMessage && errorMessage.length > 0" class="validation-errors">
            <p class="error-msg">{{errorMessage}}</p>
          </div>
          <div class="field">
            <label class="label">Email<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="email" placeholder="Enter Email Address"
                v-model="email">
            </div>
          </div>
          <div class="field">
            <label class="label">First Name<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter First Name"
                v-model="firstName">
            </div>
          </div>
          <div class="field">
            <label class="label">Last Name<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter Last Name"
                v-model="lastName">
            </div>
          </div>
          <div class="field">
            <label class="label">Cell Phone</label>
            <div class="control">
              <input class="input" type="text" placeholder="(xxx) xxx-xxxx"
                v-model="phone" @input="acceptNumber">
            </div>
          </div>
          <div class="field">
            <p>Passwords must contain at least 8 characters with at least 1: number,
              symbol, uppercase, lowercase.</p>
          </div>
          <div class="field">
            <label class="label">Password<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="password"
                v-model="password">
            </div>
          </div>
          <div class="field">
            <label class="label">Confirm Password<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="password"
                v-model="confirmPassword">
            </div>
          </div>
          <div class="level">
            <div class="level-item">
              <button :disabled="!isRequiredRegDataProvided" @click="sendRegistrationClicked"
                class="send-verify-button button is-primary">
                Send Verification Code
              </button>
            </div>
          </div>
          <p class="bail-out-message has-text-centered">
            Already have an account? <a href='#' @click="loginFromRegisterClicked">Sign In</a>
          </p>
        </div>
      </div>
    </div>
    <button @click="closeLogin" class="modal-close is-large" aria-label="close"></button>
  </div>

  <div :class="{'is-active': showVerifyActivationCode}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-register">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="security-header-label">Confirm Sign Up</div>
          </div>
        </div>
        <div class="level-right">
          <div class="level item">
            <img class="security-header-logo" src="\2290taxlogo.png">
          </div>
        </div>
      </div>
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div v-if="errorMessage && errorMessage.length > 0" class="validation-errors">
            <p class="error-msg">{{errorMessage}}</p>
          </div>

          <div class="field">
            <label class="label">Email<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="text" placeholder="Enter Email Address" v-model="email">
            </div>
          </div>
          <div class="field">
            <label class="label">Confirmation Code<span class="required">*</span></label>
            <div class="control">
              <input class="input" type="text" placeholder="Confirmation Code"
                v-model="emailConfirmationCode">
            </div>
          </div>
          <p class="bail-out-message has-text-centered">
            Lost your code? <a href='#' @click="resendVerificationEmail">Resend Code</a>
          </p>

          <p class="bail-out-message has-text-centered">
            Already have an account? <a href='#' @click="loginFromConfirmSignupClicked">Sign In</a>
          </p>
          <div class="level">
            <div class="level-item">
              <button @click="confirmEmailVerificationCodeClicked"
                class="send-verify-button button is-primary">
                Confirm Verification Code
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div :class="{'is-active': showMessageResentVerification}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-register">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="security-header-label">Confirmation Email Re-Sent</div>
          </div>
        </div>
        <div class="level-right">
          <div class="level item">
            <img class="security-header-logo" src="\2290taxlogo.png">
          </div>
        </div>
      </div>
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div class="field">
            <p class="label">A new confirmation email was sent to {{email}}.
            </p>
          </div>
          <div class="level">
            <div class="level-item">
              <button @click="emailConfirmationResentOKClicked"
                class="send-verify-button button is-primary">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div :class="{'is-active': showMessageAboutGroupMembership}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-register">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="security-header-label">Sign Up Confirmed</div>
          </div>
        </div>
        <div class="level-right">
          <div class="level item">
            <img class="security-header-logo" src="\2290taxlogo.png">
          </div>
        </div>
      </div>
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div class="field">
            <p class="label">Congratulations on successfully setting up your account!
              Before you may use your new account to access the application, an
              administrator will need to review it and assign you to an appropriate security group.
            </p>
          </div>
          <div class="level">
            <div class="level-item">
              <button @click="groupNotAssignedYetOKClicked"
                class="send-verify-button button is-primary">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div :class="{'is-active': showMFAScanCode}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-register">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="security-header-label">Setup Multi-factor Authentication</div>
          </div>
        </div>
        <div class="level-right">
          <div class="level item">
            <img class="security-header-logo" src="\2290taxlogo.png">
          </div>
        </div>
      </div>
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div class="field">
            <div class="level">
              <div class="level-item">
                <img class="mfa-qr-code-img" :src="mfaQRCodeUrl" />
              </div>
            </div>
            <p class="label">
              Or Enter the following into your authenticator application:
            </p>
            <p class="longQRCode">{{ mfaQRCodeVal }}</p>
          </div>
          <div class="level">
            <div class="level-item">
              <button @click="qrCodeRegisteredContinueClicked"
                class="send-verify-button button is-primary">
                Continue Setup
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div :class="{'is-active': showConfirmMFACode}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-register">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="security-header-label">
              Authenticator Application Value
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level item">
            <img class="security-header-logo" src="\2290taxlogo.png">
          </div>
        </div>
      </div>
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div v-if="errorMessage && errorMessage.length > 0" class="validation-errors">
            <p class="error-msg">{{errorMessage}}</p>
          </div>

          <div class="field">
            <label class="label">Confirmation Code<span class="required">*</span></label>
            <div class="control">
              <input name="one-time-code" class="input" type="text" placeholder="Confirmation Code"
                v-model="mfaConfirmationCode">
            </div>
          </div>
          <div class="level">
            <div class="level-item">
              <button @click="confirmMFAConfirmationCodeClicked"
                class="send-verify-button button is-primary">
                Confirm Authenticator Code
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div :class="{'is-active': showConfirmMFADuringSignin}" class="modal">
    <div class="modal-background"></div>
    <div class="modal-content modal-content-register">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="security-header-label">
              Authenticator Application Value
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="level item">
            <img class="security-header-logo" src="\2290taxlogo.png">
          </div>
        </div>
      </div>
      <div class="modal-content-box">
        <div class="modal-content-wrapper">
          <div v-if="errorMessage && errorMessage.length > 0" class="validation-errors">
            <p class="error-msg">{{errorMessage}}</p>
          </div>

          <div class="field">
            <label class="label">Confirmation Code<span class="required">*</span></label>
            <div class="control">
              <input name="one-time-code" class="input" type="text" placeholder="Confirmation Code"
                v-model="mfaConfirmationCode">
            </div>
          </div>
          <div class="level">
            <div class="level-item">
              <button @click="confirmMFASigninConfirmationCodeClicked"
                class="send-verify-button button is-primary">
                Confirm Authenticator Code
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import { Auth } from 'aws-amplify';
import { mapState } from 'vuex';
import {
  COGNITO_USER_POOL_ID, COGNITO_WEB_CLIENT_ID, COGNITO_REGION, COGNITO_DOMAIN, COGNITO_ENV,
} from '../shared/config';

Auth.configure({
  userPoolId: COGNITO_USER_POOL_ID,
  userPoolWebClientId: COGNITO_WEB_CLIENT_ID,
  oauth: {
    region: COGNITO_REGION,
    domain: COGNITO_DOMAIN,
    scope: ['email', 'openid', 'aws.cognito.signin.user.admin'],
    //    redirectSignIn: 'https://127.0.0.1:8080',
    //    redirectSignOut: 'https://127.0.0.1:8080',
    responseType: 'code',
  },
});

export default {
  name: 'Login',
  emits: ['signIn'],
  data() {
    return {
      areRegReqFieldsProvided: false,
      registrationErrors: [],
      errorMessage: '',
      username: '',
      password: '',
      confirmPassword: '',
      email: '',
      firstName: '',
      lastName: '',
      phone: '',
      emailConfirmationCode: '',
      mfaQRCodeUrl: '',
      mfaQRCodeVal: '',
      mfaConfirmationCode: '',
      tempUser: '',
      showLogin: false,
      showForgotPassword: false,
      showForgotPasswordConfirmation: false,
      showRegister: false,
      showVerifyActivationCode: false,
      showMessageAboutGroupMembership: false,
      showMessageResentVerification: false,
      showMFAScanCode: false,
      showConfirmMFACode: false,
      showConfirmMFADuringSignin: false,
    };
  },
  methods: {
    loginClicked() {
      this.email = '';
      this.password = '';
      this.username = '';
      this.showLogin = true;
    },

    async logoutClicked() {
      try {
        await Auth.signOut();
        this.$store.commit('users/setUser', '');
        this.email = '';
        this.password = '';
        this.username = '';
      } catch (error) {
        console.log('error signing out: ', error);
      }
      this.errorMessage = '';
      this.showLogin = true;
      this.$router.push({ path: '/' });
    },

    closeLogin() {
      this.showLogin = false;
    },

    forgotPasswordClicked() {
      this.showLogin = false;
      this.email = '';
      this.showForgotPassword = true;
    },

    cancelForgotPasswordClicked() {
      this.showForgotPassword = false;
      this.email = '';
      this.password = '';
      this.username = '';
      this.showLogin = true;
    },

    async sendForgotPasswordEmailClicked() {
      await Auth.forgotPassword(this.email);
      this.showForgotPassword = false;
      this.errorMessage = '';
      this.emailConfirmationCode = '';
      this.password = '';
      this.showForgotPasswordConfirmation = true;
    },

    async updateForgottenPasswordClicked() {
      try {
        await Auth.forgotPasswordSubmit(this.email, this.emailConfirmationCode, this.password);
        this.showForgotPasswordConfirmation = false;
        this.email = '';
        this.password = '';
        this.username = '';
        this.showLogin = true;
      } catch (e) {
        this.errorMessage = e.message;
      }
    },

    registerClicked() {
      this.showLogin = false;
      this.password = '';
      this.email = '';
      this.username = '';
      this.confirmPassword = '';
      this.firstName = '';
      this.lastName = '';
      this.phone = '';

      this.showRegister = true;
    },

    loginFromRegisterClicked() {
      this.showRegister = false;
      this.email = '';
      this.username = '';
      this.password = '';
      this.showLogin = true;
    },

    loginFromConfirmSignupClicked() {
      this.showVerifyActivationCode = false;
      this.email = '';
      this.username = '';
      this.password = '';
      this.showLogin = true;
    },

    async sendRegistrationClicked() {
      const resp = await this.signUp();
      if (resp.isCriticalError === 1) {
        if (resp.message && resp.message.length > 0) {
          this.errorMessage = resp.message;
        } else {
          this.errorMessage = 'An error occurred while establishing your account.  Please contact an application administrator.';
        }
      } else {
        this.errorMessage = '';
        this.showRegister = false;
        this.email = '';
        this.emailConfirmationCode = '';
        this.showVerifyActivationCode = true;
      }
    },

    async resendVerificationEmail() {
      await this.resendConfirmationCode(this.email);
      this.showVerifyActivationCode = false;
      this.showMessageResentVerification = true;
    },

    async confirmEmailVerificationCodeClicked() {
      const resp = await this.confirmSignUp(this.email, this.emailConfirmationCode);

      if (resp.isCriticalError === 1) {
        if (resp.message && resp.message.length > 0) {
          this.errorMessage = resp.message;
        } else {
          this.errorMessage = 'An error occurred while verifying your account.  Please contact an application administrator.';
        }
      } else {
        this.showVerifyActivationCode = false;
        this.showMessageAboutGroupMembership = true;
      }
    },

    groupNotAssignedYetOKClicked() {
      this.showMessageAboutGroupMembership = false;
      this.logoutClicked();
    },

    emailConfirmationResentOKClicked() {
      console.log('email confirmation resent ack button clicked');
      this.showMessageResentVerification = false;
      this.email = '';
      this.emailConfirmationCode = '';
      this.showVerifyActivationCode = true;
    },

    async signUp() {
      const resp = { user: null, isCriticalError: 0, message: '' };
      this.message = '';
      try {
        const ph = this.phoneNumberFormattedForAmazon();

        const { user } = await Auth.signUp({
          username: this.email,
          password: this.password,
          attributes: {
            email: this.email,
            phone_number: ph, // optional - E.164 number convention
            given_name: this.firstName,
            family_name: this.lastName,
          },
        });
        resp.user = user;
        resp.isCriticalError = 0;
        return resp;
      } catch (error) {
        resp.isCriticalError = 1;
        if (error.message) {
          resp.message = error.message;
        }
        console.log('error signing up:', error);
      }
      return resp;
    },

    async confirmSignUp(username, code) {
      const resp = { isCriticalError: 0, message: '' };
      this.message = '';
      try {
        const result = await Auth.confirmSignUp(username, code);
        if (result !== 'SUCCESS') {
          resp.isCriticalError = 1;
          resp.message = 'Invalid code provided.  Please confirm.';
        }
      } catch (error) {
        resp.isCriticalError = 1;
        resp.message = 'A critical error occurred while attempting to validate your verification code.';
        console.log('error confirming sign up', error);
      }
      return resp;
    },

    async resendConfirmationCode(username) {
      try {
        await Auth.resendSignUp(username);
      } catch (err) {
        console.log('error resending code: ', err);
      }
    },

    async login() {
      this.tempUser = '';
      await Auth.signIn(this.username, this.password).then(async (result) => {
        console.log('inside the login success handler');
        console.log(result);
        if (result.preferredMFA === 'NOMFA') {
          await this.setupMFA();
        } else if (result.challengeName === 'SOFTWARE_TOKEN_MFA') {
          console.log('ok the result is: ', result);
          // we use this just for the mfa confirm modal.
          // never use this temp val for any other purpose.
          this.tempUser = result;
          this.mfaConfirmationCode = '';
          this.errorMessage = '';
          this.showConfirmMFADuringSignin = true;
          this.showLogin = false;
        } else {
          this.getCurrentUser();
        }
      }).catch((err) => {
        console.log('inside error handler');
        console.log(err);

        switch (err.code) {
          case 'NotAuthorizedException':
            this.errorMessage = err.message;
            this.$store.commit('users/setUser', null);
            break;
          case 'UserNotConfirmedException':
            // handle the case where the user registers but doesn't confirm their
            // email but then later tries to login.
            this.showLogin = false;
            this.email = '';
            this.emailConfirmationCode = '';
            this.showVerifyActivationCode = true;
            break;
          default:
            this.errorMessage = 'Unable to login at this time using the supplied credentials';
            this.$store.commit('users/setUser', null);
            break;
        }
      });
    },

    async getCurrentUser() {
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        // console.log('getCurrentUser', currentUser);
        return currentUser;
      } catch (err) {
        console.log('Error loading user', err);
      }
      return null;
    },

    async setupMFA() {
      const user = await this.getCurrentUser();

      Auth.setupTOTP(user).then((code) => {
        const qrData = `otpauth://totp/2290TaxBillingAdmin-${COGNITO_ENV}(${user.attributes.email})?secret=${code}`;
        this.mfaQRCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURI(qrData)}&amp;size=300x300`;
        this.mfaQRCodeVal = code;
        this.showLogin = false;
        this.mfaConfirmationCode = '';
        this.showMFAScanCode = true;
      });
    },

    qrCodeRegisteredContinueClicked() {
      this.errorMessage = '';
      this.showMFAScanCode = false;
      this.showConfirmMFACode = true;
    },

    // this handler is used to confirm an mfa code as part of a normal sign in.
    async confirmMFASigninConfirmationCodeClicked() {
      try {
        this.errorMessage = '';
        Auth.confirmSignIn(this.tempUser, this.mfaConfirmationCode, 'SOFTWARE_TOKEN_MFA').then(async () => {
          this.tempUser = '';
          const currentUser = await this.getCurrentUser();
          // at this point the user is authenticated but let's verify they're in one of
          // our acceptable groups before sending them on.
          const groups = currentUser.signInUserSession.accessToken.payload['cognito:groups'];
          console.log('The groups I belong to... ', groups);
          if (groups && (groups.includes('billing-admin-power-users') || groups.includes('billing-admin-standard-users') || groups.includes('billing-admin-it-admin'))) {
            this.$store.commit('users/setUser', currentUser);
            this.$router.push({ path: '/exception-report' });
            this.showConfirmMFADuringSignin = false;
            this.$emit('signIn', 'A new user has authenticated');
          } else {
            this.$store.commit('users/setUser', '');
            this.showConfirmMFADuringSignin = false;
            this.showMessageAboutGroupMembership = true;
          }
        })
          .catch((err) => {
            this.errorMessage = err.message;
            console.log('Error condition raised!');
            console.log(err);
          });
      } catch (e) {
        if (e.code === 'EnableSoftwareTokenMFAException') {
          this.errorMessage = 'An error was returned when validating your confirmation code.  Please verify the correct value was entered.';
        } else {
          this.errorMessage = 'A critical error occurred while confirming your MFA account.  Please contact an application administrator.';
        }
        console.log('an error was caught inside confirmMFAConfirmationCodeClicked');
        console.error(e);
      }
    },

    // this handler is used by the setup mfa process only
    async confirmMFAConfirmationCodeClicked() {
      try {
        this.errorMessage = '';
        const user = await this.getCurrentUser();
        const res = await Auth.verifyTotpToken(user, this.mfaConfirmationCode);
        if (res.Status === 'SUCCESS') {
          const res2 = await Auth.setPreferredMFA(user, 'TOTP');
          if (res2 === 'SUCCESS') {
            // at this point the user is authenticated but let's verify they're in one of
            // our acceptable groups before sending them on.
            const groups = user.signInUserSession.accessToken.payload['cognito:groups'];
            if (groups && (groups.includes('billing-admin-power-users') || groups.includes('billing-admin-standard-users') || groups.includes('billing-admin-it-admin'))) {
              this.$store.commit('users/setUser', user);
              this.$router.push({ path: '/exception-report' });
              this.showConfirmMFACode = false;
            } else {
              this.$store.commit('users/setUser', '');
              this.showConfirmMFACode = false;
              this.showMessageAboutGroupMembership = true;
            }
          } else {
            console.error('res2 is: ', res2);
            this.errorMessage = 'A critical error occurred while setting up your MFA.  Please contact an application administrator.';
          }
        } else {
          console.log('an error was returned from call to verify the totp token');
          console.error(res);
          this.errorMessage = 'The confirmation token you entered was not valid.  Please try again.';
        }
      } catch (e) {
        if (e.code === 'EnableSoftwareTokenMFAException') {
          this.errorMessage = 'An error was returned when validating your confirmation code.  Please verify the correct value was entered.';
        } else {
          this.errorMessage = 'A critical error occurred while confirming your MFA account.  Please contact an application administrator.';
        }
        console.log('an error was caught inside confirm MFAConfirmationCodeClicked');
        console.error(e);
      }
    },

    acceptNumber() {
      const x = this.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      if (x[3]) {
        this.phone = `(${x[1]})  ${x[2]}-${x[3]}`;
      } else if (x[2]) {
        this.phone = `(${x[1]})  ${x[2]}`;
      } else {
        // eslint-disable-next-line prefer-destructuring
        this.phone = x[1];
      }
    },
    phoneNumberFormattedForAmazon() {
      const sanitizedValue = this.phone.replace(/\D/g, '');
      console.log(sanitizedValue);
      return sanitizedValue.length === 10 ? `+1${sanitizedValue}` : '';
    },
  },
  computed: {
    ...mapState(['user']),
    signedIn() {
      return this.$store.state.users.user && this.$store.state.users.user.username
      && this.$store.state.users.user.username.length > 0;
    },
    userName() {
      if (this.signedIn) {
        return this.$store.state.users.user.attributes.given_name;
      }
      return '';
    },
    isRequiredRegDataProvided() {
      return ((this.email && this.email.length > 10)
        && (this.firstName && this.firstName.length > 2)
        && (this.lastName && this.lastName.length > 1)
        && (this.password && this.password.length > 5)
        && (this.confirmPassword && this.confirmPassword.length > 5)
        && (this.confirmPassword === this.password)
        && (this.phone.length === 0 || (this.phoneNumberFormattedForAmazon().length === 12)));
    },
    isRequiredLoginDataProvided() {
      return this.username && this.username.length > 10
        && this.password && this.password.length > 5;
    },
  },
  async created() {
    const currUser = await this.getCurrentUser();
    // console.log('Current User is: ');
    // console.log(currUser);
    if (currUser && currUser.preferredMFA !== 'NOMFA') {
      this.$store.commit('users/setUser', currUser);
    } else {
      this.loginClicked();
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar-button {
  background-image: linear-gradient(#FBBB00,#EFCE65);
  vertical-align: top;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left:10px;
  margin-top: 10px;
  margin-right: 140px;
}

.navbar-action {
  color: #000;
  padding-left: 30px;
  padding-right: 30px;
}
.navbar-line1 {
  color: #fff;
  padding-top: 15px;
  margin-top: 15px;
}
.welcome-msg {
  padding-bottom: 20px;
}
.modal-content-register, .modal-content-login {
  color: #434343;
}
.modal-content-signIn {
  max-width: 400px;
}
.modal-content-register {
  max-width: 566px;
}
.bail-out-message {
  line-height: 2.25rem;
  color: #434343;
}
.sec-label {
  height: 14px;
  width: 53px;
  color: #434343;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 15px;
}
.login-header-logo {
  width: 229px;
  max-width: 229px;
  height: 146px;
  max-height: 146px;
}
.security-header-logo {
  width: 142px;
  height: 90px;
  max-height: 90px;
  max-width: 142px;
  margin-right: 20px;
}
.security-header-label {
  margin-left: 20px;
  height: 29px;
  /* width: 91px; */
  color: #0F3D80;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 29px;
  /* margin-right: 250px; */
}
.security-content-link {
  font-weight: 700;
  font-size: 1rem;
  margin-top: 45px;
  margin-bottom: 45px !important;
}
.modal-content-box {
  border-radius: 4px;
  background-color: #FFFFFF;
  box-shadow: 0 0 8px 0 rgba(0,0,0,0.21);
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.modal-content-wrapper {
  padding: 25px 25px;
}

.field {
  margin-top: 30px;
  margin-left: 20px;
  margin-right: 20px;
  width: 85%;
}
.send-verify-button {
  margin-top: 30px;
  margin-right: 30px;
  width: 85%;
}

.button-padded {
  font-size: 1rem;
  font-weight: bold;
  padding-left: 30px !important;
  padding-right: 30px !important;
}
.validation-errors {
  line-height: 1.5;
  background-color: red !important;
  color: #333 !important;
}
.required {
  color: red;
  margin-left: 5px;
}
.error-msg {
  color: #fff;
  margin-left: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
}

.mfa-qr-code-img {
  max-height: 300px;
  max-width: 300px;
}

.longQRCode {
  overflow-wrap: break-word;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #0F3D80;
}

@media only screen and (max-width: 768px) {
  .login-header-logo {
    width: 184px;
    max-width: 184px;
    height: 117px;
    max-height: 117px;
  }
  .modal-content {
    width: 90%;
  }
  .security-header-label {
    margin-right: 0px;
  }
  .security-header-logo {
    margin-left: 210px;
  }

}

</style>
